import React from "react";
import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <path d="M5.81818 16.2H12.1818L13.3273 19H16L9.95455 5H8.04545L2 19H4.67273L5.81818 16.2ZM9 7.52L11.38 13.9091H6.62L9 7.52Z" />
  </React.Fragment>,
  `Enhancer`
);
